import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Check, ArrowRight, Phone, Mail, Clock } from 'lucide-react';
import { SEO } from '../components/SEO';

const Thanks = () => {
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerid');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-wrapper" data-testid="thanks-page">
      <SEO
        title="Thank You - Legal Emphasis"
        description="Thank you for contacting Legal Emphasis. Our team will review your request and reach out within 24 hours."
      />

      {/* Hero Confirmation */}
      <section className="bg-[#0A2A5E] py-20 md:py-28" data-testid="thanks-hero">
        <div className="le-container">
          <div className="max-w-2xl mx-auto text-center">
            <div className="w-20 h-20 bg-white/10 flex items-center justify-center mx-auto mb-8">
              <Check className="text-white" size={40} strokeWidth={2.5} />
            </div>
            <h1 className="le-heading-1 text-white mb-4">Thank You for Reaching Out</h1>
            <p className="text-lg text-gray-300 leading-relaxed">
              Your request has been received. A member of our legal team will contact you within 24 hours to discuss your needs.
            </p>
            {customerId && (
              <p className="text-gray-400 text-sm mt-6" data-testid="thanks-customer-ref">
                Reference ID: {customerId}
              </p>
            )}
          </div>
        </div>
      </section>

      {/* Contact Info Strip */}
      <section className="py-12 bg-[#F8F9FA] border-y border-[#E2E8F0]" data-testid="thanks-contact">
        <div className="le-container max-w-4xl">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 text-center">
            <div className="flex items-center gap-3">
              <Phone size={18} className="text-[#0A2A5E]" />
              <a href="tel:+18887505204" className="text-gray-700 hover:text-[#0A2A5E] transition-colors text-sm">
                +1 (888) 750-5204
              </a>
            </div>
            <div className="flex items-center gap-3">
              <Mail size={18} className="text-[#0A2A5E]" />
              <a href="mailto:info@legalemphasis.com" className="text-gray-700 hover:text-[#0A2A5E] transition-colors text-sm">
                info@legalemphasis.com
              </a>
            </div>
            <div className="flex items-center gap-3">
              <Clock size={18} className="text-[#0A2A5E]" />
              <span className="text-gray-700 text-sm">Mon – Fri, 9 AM – 6 PM</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="le-section bg-white" data-testid="thanks-cta">
        <div className="le-container max-w-2xl text-center">
          <h2 className="le-heading-2 mb-4">Explore Our Services</h2>
          <p className="text-gray-600 mb-8">
            While you wait, feel free to learn more about our practice areas and how we help businesses across the country.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/services/corporate-business-contracts" className="le-btn-primary" data-testid="thanks-services-btn">
              View Services
              <ArrowRight size={18} />
            </Link>
            <Link to="/" className="le-btn-secondary" data-testid="thanks-home-btn">
              Back to Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Thanks;
